import React, { useMemo, memo, useState, useEffect } from "react";
import { ImageContainer, Image } from "../styles/3D/styles";
import { AppWrapper } from "../styles/3D/styles";
import ThreeJsScene from "./scene";
import { getDeviceInfo } from "../data/utils";
import {
  ButtonContainer,
  FooterWrapper,
  Button,
} from "../styles/components/footer";
import Credits from "../components/credits";

const isWebGLAvailableCheck = () => {
  try {
    const canvas = document.createElement("canvas");
    return !!(
      window.WebGLRenderingContext &&
      (canvas.getContext("webgl") || canvas.getContext("experimental-webgl"))
    );
  } catch (e) {
    return false;
  }
};

const ThreeJsComponent = ({ datoContentData }) => {
  const [isWebGLAvailable, setIsWebGLAvailable] = useState(true);

  const componentContent = useMemo(() => {
    return Object.values(datoContentData).map(component => ({
      key: component.moduleTitle ? component.moduleTitle : component.key,
      content: component,
    }));
  }, [datoContentData]);

  const { isMobile } = getDeviceInfo();

  let ctaLink, ctaButtonText;

  const articleData = datoContentData.find(
    item => item.key === "article--data"
  );

  const footerComponent = componentContent.find(
    c => c.key === "component--footer"
  );

  const footerItems = footerComponent?.content?.content ?? [];

  const creditsComponent = footerItems.find(
    item => item.__typename === "DatoCmsCredit"
  );

  const footerData = footerItems.reduce(
    (acc, item, index) => {
      if (item.__typename === "DatoCmsHeadline") {
        acc.heading[index] = item.text;
      } else if (item.__typename === "DatoCmsCta") {
        acc.cta[index] = {
          url: item.url,
          buttonText: item.buttonText,
        };
        ctaLink = item.url;
        ctaButtonText = item.buttonText;
      }
      return acc;
    },
    { heading: {}, cta: {} }
  );

  const handleClick = () => {
    if (ctaLink) {
      window.location.href = ctaLink;
    }
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (!isWebGLAvailableCheck()) {
      console.error("WebGL is not supported in this browser");
      setIsWebGLAvailable(false);
      return;
    }
  }, []);

  return (
    <>
      <AppWrapper
        className="app-wrapper"
        onClick={isMobile ? handleClick : null}
        $isWebGLAvailable={isWebGLAvailable}
      >
        {isWebGLAvailable ? (
          <ThreeJsScene footerData={footerData} articleData={articleData} />
        ) : (
          <ImageContainer>
            <Image
              src="https://www.datocms-assets.com/40484/1745999958-new-logo_trident-2x.png"
              alt="Trident"
            />
          </ImageContainer>
        )}
      </AppWrapper>
      <FooterWrapper>
        <ButtonContainer>
          <Button
            onClick={handleClick}
            $isWebGLAvailable={isWebGLAvailable}
            $primaryColor={
              articleData.showNextArticle
                ? articleData?.colors?.next_article_primary
                : articleData?.colors?.primary
            }
            $secondaryColor={
              articleData.showNextArticle
                ? articleData?.colors?.next_article_secondary
                : articleData?.colors?.secondary
            }
          >
            {ctaButtonText || "Read more"}
          </Button>
        </ButtonContainer>
        {creditsComponent && (
          <Credits
            creditsComponent={creditsComponent}
            colors={articleData?.colors}
          />
        )}
      </FooterWrapper>
    </>
  );
};

export default memo(ThreeJsComponent);
